import React from "react";

const SvgSmallWine = props => (
  <svg viewBox="0 0 215 215" {...props}>
    <path
      d="M137.3 29.4l-1.4-4H79l-1.4 4C71.3 47.1 63.1 77 69.9 98.6c.4 1.1.7 2 1.1 3.1 1.1 2.6 2.4 5.1 4 7.4 4.2 5.9 11.1 10.1 18.9 12.4 3.2 1 6.5 1.5 9.9 1.9v53.1H80.2v7.6H136v-7.6h-24.3v-53.1c3.1-.4 6.2-1 9.3-1.8 8-2.3 14.9-6.4 19-12.4 1.9-2.7 3.3-5.6 4.5-8.7.2-.6.5-1.2.6-1.8 6.8-21.7-1.5-51.8-7.8-69.3zM76.1 98.6c-1-2.4-1.5-4.9-2-7.5l-.7-5.8c-.7-10.7 1.1-22.5 3.5-32.7.4-2 .8-3.9 1.4-5.8 1.7-6.2 3.5-11.3 4.9-15.2h48.5c1.3 3.8 3.1 9.3 4.6 15.2 1 2.9 1.7 5.8 1.7 5.8 2.5 10.2 4.3 22.1 3.5 32.7-.1 2.4-.7 5.8-.7 5.8-.4 2.5-1.1 5-1.9 7.4l-.1.2-62.7-.1z"
      fill="currentColor"
    />
  </svg>
);

export default SvgSmallWine;